import { render, staticRenderFns } from "./tk_list.vue?vue&type=template&id=c152a614&scoped=true&"
import script from "./tk_list.vue?vue&type=script&lang=js&"
export * from "./tk_list.vue?vue&type=script&lang=js&"
import style0 from "./tk_list.vue?vue&type=style&index=0&id=c152a614&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c152a614",
  null
  
)

export default component.exports